export function changeTagName(element: HTMLElement, newTagName: string) {
  const newElement = document.createElement(newTagName);
  Array.from(element.attributes).forEach((attr) => {
    newElement.setAttribute(attr.name, attr.value);
  });
  newElement.innerHTML = element.innerHTML;
  element.parentNode?.replaceChild(newElement, element);
  return newElement;
}
